import { parseFormAsObject } from '@open-wc/form-helpers';
import { FASTElement, Updates, customElement, observable } from '@microsoft/fast-element';
import type { FASTSelect, FormAssociatedElement } from '@microsoft/fast-foundation';
import { neutralBaseColor } from '@adaptive-web/adaptive-ui/reference';

import { SiteColors, darkModeQuery } from '../../style.js';
import template from './template.js';
import styles from './styles.js';

@customElement({
	name: 'contact-form',
	template,
	styles
})
export class ContactForm extends FASTElement {
	@observable
	public form!: HTMLFormElement;

	@observable
	public received: boolean = false;
	protected receivedChanged(): void {
		if (this.received) {
			setTimeout(() => {
				this.received = false;
				this.form.reset();
			}, 10000);
		}
	}

	public async handleSubmit(): Promise<void> {
		if (!this.form.checkValidity()) {
			const fields = Array.from(this.form.elements).filter(field => field.hasAttribute('required')) as FormAssociatedElement[];

			const next = fields.find(field => !field.checkValidity());
			next?.reportValidity();
			next?.focus();

			return;
		}

		const formData = parseFormAsObject(this.form);

		await fetch('https://api.trans-stat.com/contact', {
			method: 'POST',
			body: JSON.stringify(formData),
			mode: 'no-cors'
		}).then(res => {
			this.received = true;
		});

		return;
	}

	public async connectedCallback(): Promise<void> {
		super.connectedCallback();

		await Updates.next();
		neutralBaseColor.setValueFor(this, SiteColors.darkBlue);
	}

	get isDarkMode() {
		return darkModeQuery.matches;
	}
}